import { productDetailPageInit } from "components/product_detail_page/product_detail_page";
import { pdpScrapperInit } from "components/pdp_scrapper/pdp_scrapper";
import { whereToBuyInit } from "components/where_to_buy/where_to_buy";

if (document.getElementsByClassName('page-template-template-signage-product-new').length) {
    productDetailPageInit();
} else if (document.getElementsByClassName('authorized-partner-new').length) {
    whereToBuyInit();
} else {
    pdpScrapperInit();
}
